var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFaqAccordion',{attrs:{"items":_vm.myItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }